import { Card } from "@/components/ui/card";
import { Lock } from "lucide-react";

export function FeatureLocked({ label }) {
  return (
    <div data-testid="feature-locked" className="flex flex-col items-center justify-center text-center py-20 px-6">
      <div className="h-14 w-14 rounded-2xl bg-secondary flex items-center justify-center mb-4">
        <Lock className="h-6 w-6 text-muted-foreground" />
      </div>
      <h2 className="font-display text-xl font-bold">{label} isn't in your plan</h2>
      <p className="text-muted-foreground mt-1 max-w-md">Upgrade your DineFlo subscription to unlock {label}. Contact your platform administrator to change your plan.</p>
    </div>
  );
}


export function StatCard({ label, value, icon: Icon, accent, testid }) {
  return (
    <Card data-testid={testid} className="p-5 border-border rounded-2xl">
      <div className="flex items-start justify-between">
        <div>
          <p className="text-xs uppercase tracking-[0.15em] text-muted-foreground">{label}</p>
          <p className="font-display text-3xl font-bold mt-2">{value}</p>
        </div>
        {Icon && (
          <div className={`h-10 w-10 rounded-xl flex items-center justify-center ${accent || "bg-primary/10 text-primary"}`}>
            <Icon className="h-5 w-5" />
          </div>
        )}
      </div>
    </Card>
  );
}

export function PageHeader({ title, subtitle, children }) {
  return (
    <div className="flex flex-wrap items-end justify-between gap-4 mb-6">
      <div>
        <h1 className="font-display text-2xl sm:text-3xl font-bold tracking-tight">{title}</h1>
        {subtitle && <p className="text-muted-foreground mt-1">{subtitle}</p>}
      </div>
      <div className="flex gap-2">{children}</div>
    </div>
  );
}
